<template>
  <div class="checkout-info-wrapper">
    <div class="checkout-info-title" v-if="!isSmall">
      Pedido {{ order.orderId }}
    </div>
    <div class="checkout-info-header-details">
      <div>Realizado em {{ order.createdAt | dateFilter }}</div>
      <div>
        {{ products.length > 1 ?
          `${products.length} itens` :
          `${products.length} item`
        }}
      </div>
    </div>
    <div class="checkout-info-itens-wrapper">
      <div
        class="item"
        v-for="(item, indexItem) in products"
        :key="item+indexItem"
      >
        <div class="img">
          <asset-v3 v-if="item.image" absolutPath :name="item.image || 'undefined'" width="48" />
          <asset-v3 v-else name="bag.svg" dir="icons" width="48" />
        </div>
        <div class="item-info">
          <div class="item-name">{{ item.name }}</div>
          <div class="item-details">
            <div class="item-quantity">Qtd {{item.amount >= 10
              ? item.amount
              : `0${item.amount}`}}
            </div>
            <div class="item-price">{{ moneyFilter(item.value)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout-info-adress">
      <div class="checkout-info-adress-title">Endereço de entrega</div>
      <div class="checkout-info-adress-values">
        <span>{{ user.name }}</span>
        <span>
          {{ `${order.shipping.addressStreet} ${order.shipping.addressNumber}` }}
          </span>
        <span>{{ order.shipping.city }} - {{ order.shipping.state }}</span>
        <span>{{ order.shipping.postalCode }}</span>
        <span>Tel: {{ user.phone }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';

export default {
  components: {
    AssetV3,
  },
  mixins: [StringMixin, UtilMixin],
  props: {
    products: {
      type: Array,
    },
    user: {
      type: Object,
    },
    order: {
      type: Object,
    },
  },
  computed: {
    isSmall() {
      return this.isMobile();
    },
  },
};
</script>
<style lang="scss" scoped>
.checkout-info-wrapper {
  margin-top: 24px;
  margin-left: 36px;
  margin-right: 36px;
}
.checkout-info-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
}
.checkout-info-header-details {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  color: #637381;
}
.item-name {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
}
.item-details {
  display: flex;
  justify-content: space-between;
}
.item-quantity, .item-price {
  font-size: 12px;
  line-height: 16px;
  color: #637381;
}
.checkout-info-itens-wrapper {
  max-height: 180px;
  overflow: auto;
  margin-top: 16px;
}
.checkout-info-itens-wrapper .item {
  display: flex;
  margin-top: 16px;
}
.checkout-info-itens-wrapper .item .img{
  margin-right: 20px;
}
.checkout-info-itens-wrapper .item .item-info{
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #DFE3E8;
  padding-bottom: 12px;
  width: 100%;
  margin-right: 10px;
}
.checkout-info-itens-wrapper .item:last-child .item-info{
  border-bottom: unset;
}
.checkout-info-deliver-prediction {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
  margin-top: 18px;
  margin-bottom: 24px;
}
.checkout-info-adress {
  margin-top: 24px;
  margin-bottom: 24px;
}
.checkout-info-adress-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
  margin-bottom: 8px;
}
.checkout-info-adress-values {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
}
.checkout-info-payment-method-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.span-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
}
.span-value {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
}
.payment-method-detail {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #DFE3E8;
  padding-bottom: 12px;
  margin-top: 12px;
}
.payment-method-detail:last-child {
  border-bottom: unset;
}
.payment-method-detail .title {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
}
.payment-method-detail .value {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.payment-method-detail .value span {
  font-size: 12px;
  line-height: 16px;
  color: #212B36;
  font-weight: normal;
}
@media (max-width: $sm) {
  .checkout-info-wrapper {
    margin-top: unset;
    margin-left: unset;
  }
}
</style>
